import React, { useEffect, useState } from "react";
import { Training } from "../../../../../types/types";
import Service from "../../../../../services/workbooks";
import Collapsible from "react-collapsible";
import GetExercise from './GetExercise';
import Weekday from "../../../../../common/Weekday";


type Props = {
  workbook_id: number;
  userId: number;
};

const ShowTrainings: React.FC<Props> = ({ workbook_id, userId }) => {
  const [trainings, setTrainings] = useState<Training[]>([]);
  const [expandedItemIndex, setExpandedItemIndex] = useState<number | null>(null);

  useEffect(() => {
  Service.getTrainingsByUserId(workbook_id, userId).then((response) => {
    if (response.data.length > 0) {
      const parsedTrainings = response.data
        .map((training: Training) => ({
          ...training,
          date: new Date(training.date).toISOString().split('T')[0],
        }))
        .sort((a: Training, b: Training) => new Date(b.date).getTime() - new Date(a.date).getTime()); // sort by newest first

      setTrainings(parsedTrainings);
    }
  });

  const expandedItemIndex = localStorage.getItem('expandedItemIndex');
  if (expandedItemIndex !== null) {
    setExpandedItemIndex(parseInt(expandedItemIndex));
  }
}, [workbook_id]);

  const handleItemClick = (index: number) => {
    setExpandedItemIndex((prevState) => (prevState === index ? null : index));
    localStorage.setItem('expandedItemIndex', index.toString());
  };

  const isItemExpanded = (index: number): boolean => expandedItemIndex === index;

  return (
    <div>
      <ul>
        {trainings.map((item, index) => (
          <li key={index}>
            <Collapsible
              trigger={
                <div
                  style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '10px',
                  }}
                  onClick={() => handleItemClick(index)}
                >
                  <span style={{ marginRight: '10px', width: '350px', textAlign: 'right' }}>
                    <Weekday date={item.date} />
                  </span>
                </div>
              }
              open={isItemExpanded(index)}
            >
              <GetExercise training_id={item.id} userId={userId}></GetExercise>
            </Collapsible>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ShowTrainings;
